import { createContext, useContext } from 'react'

const mfIdContext = createContext('')

// biome-ignore lint/nursery/useComponentExportOnlyModules: <explanation>
export const useMfId = () => useContext(mfIdContext)

export function MfProvider({ children, mfId }: { children: React.ReactNode; mfId: string }) {
  return <mfIdContext.Provider value={mfId}>{children}</mfIdContext.Provider>
}
